import { Fragment, useState } from 'react';
import { Box } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import Cookies from 'universal-cookie';

import { CloseIcon } from 'Asset/icon';
import { Condition, Iteration } from 'Component/others';
import { TextRegular, TextSemiBold } from 'UiKit/typography';
import ButtonOutline from 'UiKit/button/buttonOutline';
import ButtonSolid from 'UiKit/button/buttonSolid';
import { useScheduleGenerateState } from 'View/schedule-generate/state';
import { TUTORIAL_COOKIE_NAME, buildTutorialData } from './const';

import styles from './styles.module.css';

const TutorialModal = () => {
  const { t } = useTranslation('schedule-generate');
  const tutorialData = buildTutorialData(t);
  const { updateState } = useScheduleGenerateState();
  const [activeIndex, setActiveIndex] = useState(1);
  const cookies = new Cookies();

  const handleNext = () => {
    if (activeIndex < tutorialData.length) {
      setActiveIndex((prev) => prev + 1);
    } else {
      handleClose();
      const expirationDate = new Date();
      expirationDate.setFullYear(expirationDate.getFullYear() + 1);
      cookies.set(TUTORIAL_COOKIE_NAME, 'viewed', { expires: expirationDate, path: '/' });
    }
  };

  const handlePrev = () => {
    if (activeIndex > 1) {
      setActiveIndex((prev) => prev - 1);
    }
  };

  const handleClose = () => {
    setActiveIndex(1);
    updateState({ openTutorialModal: false });
  };
  const nextButtonText = activeIndex === tutorialData.length ? t('tutorialDone') : t('tutorialNext');
  return (
    <Fragment>
      <Box className={styles['modal__container']}>
        <Box className={styles['item__container']}>
          <CloseIcon onClick={handleClose} width="15px" height="15px" className={styles['item-close__icon']} />
          <Box className={styles['item-gif__container']}>
            <img key={activeIndex} src={tutorialData[activeIndex - 1].gif} alt="tutorial" className={styles['item-gif__gif']} />
          </Box>
          <Box className={styles['item-text__container']}>
            <TextSemiBold className={styles['item-text__title']}>{tutorialData[activeIndex - 1].title}</TextSemiBold>
            <TextRegular className={styles['item-text__desc']}>{tutorialData[activeIndex - 1].desc}</TextRegular>
          </Box>
          <Box className={styles['item-indicator__container']}>
            <Iteration
              items={tutorialData}
              render={(_, index) => (
                <Box className={styles['item-indicator__container--item']} key={index}>
                  <Box
                    className={`${styles['item-indicator__container--circle']} ${
                      index === activeIndex - 1 ? styles['item-indicator__container--circle--active'] : ''
                    }`}
                  />
                </Box>
              )}
            />
          </Box>
          <Box className={styles['item-footer__container']}>
            <Condition statement={activeIndex > 1}>
              <ButtonOutline onClick={handlePrev}>{t('tutorialPrev')}</ButtonOutline>
            </Condition>
            <ButtonSolid onClick={handleNext}>{nextButtonText}</ButtonSolid>
          </Box>
        </Box>
      </Box>
      <Box className={styles['modal__container--overlay']} onClick={handleClose}></Box>
    </Fragment>
  );
};

export default TutorialModal;
